<template>
  <v-card class="mt-5">
    <AppVCardTitle label="Rapport de non-comformité"/>
    <v-card-text class="pb-0">
      <p class="mb-0">S'il y en a, décrivez les éléments non-conformes rencontrés</p>
    </v-card-text>
    <v-textarea
        class="px-4"
        v-model="value.comment"
        placeholder="Affiche mal collée, client pas présent sur le site, anomalies diverses etc."
        filled
        auto-grow
        rows="5"
    />
  </v-card>
</template>

<script lang="ts">
import AppVCardTitle from "@/components/MaintenanceViewReport/ImplementedForms/Oleo100Preventive/App/VCardTitle.vue";

export default {
  name: "NonComplianceReport",
  components: {
    AppVCardTitle,
  },
  props: {
    value: {
      type: Object,
      required: true,
    }
  },
}
</script>